import React from "react";
import PageLayout from "../../layouts/PageLayout";
import { Heading } from "../../components/elements";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

export default function Zxf2() {
    return (
        <PageLayout>
        <Helmet>
          <title>Invest in ZXF</title>
          <meta name="description" content="Claim 10,000 ZXF Token, ZXF token is the cryptocurrency that powers the 0xFactory platform, not only can you trade ZXF like any other cryptocurrency." />
          <meta name="keywords" content="0xtools script, crypto script, dapp, token creator, smart contract generator" />
          <meta name="author" content="0xFactory" />

          {/* Open Graph (for Facebook, LinkedIn, etc.) */}
          <meta property="og:title" content="Invest in ZXF" />
          <meta property="og:description" content="Claim 10,000 ZXF Token, ZXF token is the cryptocurrency that powers the 0xFactory platform, not only can you trade ZXF like any other cryptocurrency." />
          <meta property="og:image" content="https://0xfactory.com/images/airdrop.png" />
          <meta property="og:url" content="https://0xfactory.com/zxf" />
          <meta property="og:type" content="website" />

          {/* Twitter Card (for Twitter sharing) */}
          <meta name="twitter:title" content="Invest in ZXF" />
          <meta name="twitter:description" content="Claim 10,000 ZXF Token, ZXF token is the cryptocurrency that powers the 0xFactory platform, not only can you trade ZXF like any other cryptocurrency." />
          <meta name="twitter:image" content="https://0xfactory.com/images/airdrop.png" />
          <meta name="twitter:card" content="0xtools_script" />
        </Helmet>
            <Container fluid>
                <Heading as="h2" className="mc-overview-title">Invest in ZXF</Heading>
                    <Row xs={1} sm={2} xl={2}>
                            <Col xs={12} sm={12} xl={12}>
                                <div className="text-center">
                                  <h2>We will launch ZXF token on Four.meme platform soon</h2>
                                </div>
                                <br/>
                                <div>
                                    ZXF token is the cryptocurrency that powers the 0xFactory platform, not only can you trade ZXF like any other cryptocurrency, you can also use ZXF in a wide range of applications and use cases.
                                </div>
                                <br/>
                                <div className="text-center">
                                <a href="https://t.me/mohamedmox" target="_blank" rel="noreferrer"><h2 style={{color:'yellow'}}>Become very early investor</h2></a>
                                <br/>
                                </div>

                                <br/>
                                <div className="text-center">
                                        <img src="images/ico.png" alt="airdrop" />
                                </div>
                                <br/>
                                <div className="text-center">
                                    <h2 style={{color:'yellow'}}>Be the first to ride the wave!</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <a href="https://t.me/mohamedmox" target="_blank" rel="noreferrer"><h1 style={{color:'white'}}>Contact me</h1></a>
                                </div>
                                <br/>
                                <div><h3>Minimum Investment: 1 BNB</h3></div>
                                <br/>
                                <div><h3>100% Risk FREE</h3></div>
                                <br/>
                                <h3>Details: </h3>
                                <div>1- We aim to raise 5–10 BNB to launch the ZXF token on the Four.Meme platform.</div>
                                <div>2- These funds will be used for the initial buy operation during token creation.</div>
                                <div>3- Each early investor will receive a share of tokens proportional to their BNB contribution.</div>
                                <div>4- To protect both the token and its investors, early investor tokens will be distributed only after a successful launch on Four.Meme and listing on PancakeSwap.</div>
                                <div>5- If the launch on Four.Meme is not successful within one month, all early investors will receive a full 100% refund with no loss.</div>
                                <br/>
                            </Col>
                    </Row>
                </Container>
        </PageLayout>
    )
}
